import { APIRoute } from '@/modules/utils'
import { IRI } from 'emt-library'

export const Route = (deleteIRI: IRI): APIRoute => ({
  method: 'DELETE',
  path: deleteIRI,
})

export type Body = never
export type Response = never
